import { css } from "@emotion/react";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "antd";

import { Blank } from "../Layout";

function ReactError() {
  const history = useHistory();

  const handleClick = useCallback(() => {
    history.go("/");
  }, []);

  return (
    <Blank>
      <div css={reactError}>
        <div className="ant-result ant-result-info">
          <div className="ant-result-title">500</div>
          <div className="ant-result-subtitle">
            Sorry, something went wrong.
          </div>
          <div className="ant-result-extra">
            <Button type="primary" shape="round" onClick={handleClick}>
              Home
            </Button>
          </div>
        </div>
      </div>
    </Blank>
  );
}

const reactError = (theme) => css`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default ReactError;
